import type { EditorViewState } from './editor-view.types';

export const state: EditorViewState = {
  isPreview: false,
  documentId: '',
  recipientId: '',
  authId: '',
  authToken: { jwt: '', exp: 0 },
  tokenIsSynced: true,
  documentStatusSigned: false,
  documentRecalled: false,
  previewTokenExpired: false,
};

export enum EditorViewAction {
  EmitSetDocumentStatusSigned = 'emitSetDocumentStatusSigned',
  EmitDocumentRecalled = 'emitDocumentRecalled',
  EmitPreviewTokenExpired = 'emitPreviewTokenExpired',
  EmitNewToken = 'emitNewToken',
  SetToken = 'setToken',
  SetTokenIsSynced = 'setTokenIsSynced',
  SetDocumentId = 'setDocumentId',
  SetRecipientId = 'setRecipientId',
  SetAuthId = 'setAuthId',
  SetIsPreview = 'setIsPreview',
}

export enum EditorViewMutation {
  SetToken = 'setToken',
  SetTokenIsSynced = 'setTokenIsSynced',
  SetDocumentId = 'setDocumentId',
  SetRecipientId = 'setRecipientId',
  SetAuthId = 'setAuthId',
  SetIsPreview = 'setIsPreview',
  SetDocumentStatusSigned = 'setDocumentStatusSigned',
  SetDocumentRecalled = 'setDocumentRecalled',
  SetPreviewTokenExpired = 'setPreviewTokenExpired',
}
